import PropTypes from "prop-types";
import { useCallback } from "react";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { FormattedMessage } from "react-intl";
import { quotationFlightShape } from "app/utils/propTypes.js";
import QuotationFlightsItem from "app/pages/Booking/Quotation/Flight/QuotationFlightsItem.jsx";
import "./QuotationFlights.scss";

const QuotationFlights = ({
	departureDate,
	travelByTrainAvailable,
	luggageMaxCount,
	onLuggageClick = () => {},
	onChange,
	flights,
}) => {
	const handleLuggageClick = useCallback(() => {
		onLuggageClick();
	}, []);

	// question : est)ce qu'il faut afficher vol direct si c'est un vol ? ou bien tout le temps 'direct'
	const flightsNode = flights.map((flight, index) => {
		return (
			<QuotationFlightsItem
				isTransportAvailableForSpecialOffer={flight.specialOffer}
				transportationType={flight.type}
				luggageMaxCount={luggageMaxCount}
				travelByTrainAvailable={travelByTrainAvailable}
				key={flight.code}
				onLuggageClick={handleLuggageClick}
				onChange={onChange}
				flight={flight}
				departureDate={departureDate}
				displayRouteDetails={index === 0}
			/>
		);
	});

	const noVisibleFlight = flights.length === 0;

	return (
		<div className="quotation-flights">
			<div className="quotation-flights__list">
				{noVisibleFlight ? (
					<AlertMessage
						message={<FormattedMessage id="quotation.flights.filter.no.flight" />}
					/>
				) : (
					flightsNode
				)}
			</div>
		</div>
	);
};

QuotationFlights.defaultProps = {
	flights: [],
};

QuotationFlights.propTypes = {
	departureDate: PropTypes.number,
	travelByTrainAvailable: PropTypes.bool,
	luggageMaxCount: PropTypes.number,
	onLuggageClick: PropTypes.func,
	onChange: PropTypes.func,
	flights: PropTypes.arrayOf(quotationFlightShape),
};

export default QuotationFlights;
